/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 16:19:05
 * @Explain: 设置管理
 */
export default {
  // 设置管理
  'SETTING.MANAGE.SENDER.INFO': '发件人信息',
  'SETTING.MANAGE.SENDING.STRATEGY': '发件策略',
  'SETTING.MANAGE.DATA.SYNCHRONIZATION': '数据同步（开发者）',
  'SETTING.MANAGE.TEST.LISTS': '测试人列表',

  // 用户管理
  'USERS.MANAGE.LIST.USER.ROLE': '用户',
  'USERS.MANAGE.LIST.USER.TITLE': '用户管理',
  'USERS.MANAGE.LIST.USERNAME': '用户名',
  'USERS.MANAGE.LIST.ROLE': '角色',
  'USERS.MANAGE.LIST.EMAIL.ADDRESS': '邮箱地址',
  'USERS.MANAGE.LIST.JOINING.TIME': '加入时间',
  'USERS.MANAGE.LIST.2AF.STATUS': '双因素认证',
  'USERS.MANAGE.LIST.BEING.INVITED': '邀请中',
  'USERS.MANAGE.LIST.INVITER': '邀请人',
  'USERS.MANAGE.LIST.INVITE.USER': '邀请用户',
  'USERS.MANAGE.LIST.EDIT.USER': '编辑用户',
  'USERS.MANAGE.LIST.DEL.USER': '删除用户',
  'USERS.MANAGE.LIST.DEL.USER.TIPS':
    '您即将从项目中删除此用户。此用户的所有访问权限都将被吊销。',
  'USERS.MANAGE.LIST.REINVITE': '重发邀请邮件',
  'USERS.MANAGE.LIST.REINVITE.SUCCESS': '已重发',

  'USERS.MANAGE.ADD.EDIT.INVITE.TITLE': '邀请信息',
  'USERS.MANAGE.ADD.EDIT.INVITE': '邀请',
  'USERS.MANAGE.ADD.EDIT.EMAIL': '输入用户的邮箱地址',
  'USERS.MANAGE.ADD.EDIT.ENTER.EMAIL': '输入用户的邮箱地址',
  'USERS.MANAGE.ADD.EDIT.EMAIL.EXIST': '此用户已在项目中，请直接编辑用户角色',
  'USERS.MANAGE.ADD.EDIT.CHOOSE.ROLE': '选择被邀请用户的角色',
  'USERS.MANAGE.ADD.SUBMIT.SUCCESS': '您已邀请{email}({role})加入您的项目',

  'USERS.MANAGE.MY.PROFILES.BASIC': '基本信息',
  'USERS.MANAGE.MY.PROFILES.USERNAME': '用户名',
  'USERS.MANAGE.MY.PROFILES.EMAIL.ADDRESS': '邮箱地址',
  'USERS.MANAGE.MY.PROFILES.ACCOUNT.SECURITY': '账号安全',
  'USERS.MANAGE.MY.PROFILES.2FA.TITLE': '双重身份验证',
  'USERS.MANAGE.MY.PROFILES.AUTHENTICATOR.APP': '身份验证器应用程序',
  'USERS.MANAGE.MY.PROFILES.AUTHENTICATOR.APP.DESC':
    '当系统提示时，使用身份验证应用程序或浏览器扩展程序获取双因素身份验证码。',
  'USERS.MANAGE.MY.PROFILES.SCAN.QR.CODE': '扫描验证码',
  'USERS.MANAGE.MY.PROFILES.SCAN.QR.CODE.DESC':
    '身份验证器应用程序，如Authy、Microsoft身份验证器、Google身份验证器等，去扫描',
  'USERS.MANAGE.MY.PROFILES.SCAN.QR.CODE.TIPS1': '无法扫描？您可以使用',
  'USERS.MANAGE.MY.PROFILES.SCAN.QR.CODE.TIPS2': '设置密钥',
  'USERS.MANAGE.MY.PROFILES.SCAN.QR.CODE.TIPS3': '手动配置身份验证器应用程序',
  'USERS.MANAGE.MY.PROFILES.ENTER.SIX.DIGIT.CODE':
    '输入验证器上的{num}位数字码',
  'USERS.MANAGE.MY.PROFILES.BACKUP.VERIFY.CODES': '备份验证码',
  'USERS.MANAGE.MY.PROFILES.BACKUP.VERIFY.CODES.DESC':
    '为您的帐户启用2FA后，如果您丢失了设备，您将需要这些备份代码以访问您的SmartLink帐户。',
  'USERS.MANAGE.MY.PROFILES.COPY.CODE': '复制代码',
  'USERS.MANAGE.MY.PROFILES.COPY.CODE.FIRST': '请先复制代码',
  'USERS.MANAGE.MY.PROFILES.ENABLE.2FA': '启用2FA',
  'USERS.MANAGE.MY.PROFILES.YOU.2FA.KEY': '你的双重验证密钥',
  'USERS.MANAGE.MY.PROFILES.DISABLED.2FA': '禁用双重身份验证',
  'USERS.MANAGE.MY.PROFILES.DISABLED.2FA.DESC':
    '双重身份验证禁用后，后续将不再需要双重验证。',
  'USERS.MANAGE.MY.PROFILES.DISABLED.SUCCESS': '双重因素验证禁用成功',
  'USERS.MANAGE.MY.PROFILES.ENABLE.SUCCESS': '双重因素验证启用成功',
  'USERS.MANAGE.MY.PROFILES.TIME.SETTING': '时间设置',
  'USERS.MANAGE.MY.PROFILES.TIMEZONE': '时区',
  'USERS.MANAGE.MY.PROFILES.TIME.FORMAT': '时间格式',

  // 域名配置 - 发送域名设置
  'DOMAIN.NAME.CONFIG.TITLE': '域名配置',
  'DOMAIN.NAME.CONFIG.DESC': '验证域名并根据需要新增发件人地址',
  'DOMAIN.NAME.CONFIG.ADD': '添加域名',
  'DOMAIN.NAME.CONFIG.SEND.OTHER':
    '{platform}（支持添加已在以下合作伙伴处验证过的发信域名）',
  'DOMAIN.NAME.CONFIG.SEND.PLACEHOLDER.TENCENT':
    '请填写您的自有域名，并支持域名DNS的配置，以便后期完成域名的验证',
  'DOMAIN.NAME.CONFIG.SEND.PLACEHOLDER.OTHER':
    '请填写您已验证过的发信域名，否则可能导致发信失败',
  'DOMAIN.NAME.CONFIG.SEND.MSG':
    '100个字符以内，支持英文、数字、-，不能以-开头或结尾，且-不能连续出现',
  'DOMAIN.NAME.CONFIG.SEND': '发信域名',
  'DOMAIN.NAME.CONFIG.STATE': '状态',
  'DOMAIN.NAME.CONFIG.TO.BE.VERIFIED': '待验证',
  'DOMAIN.NAME.CONFIG.VERIFICATION.PASSED': '验证通过',
  'DOMAIN.NAME.CONFIG.VERIFICATION.FAILED': '验证不通过',
  'DOMAIN.NAME.CONFIG.VERIFYING': '验证中',
  'DOMAIN.NAME.CONFIG.NO.VERIFICATION.REQUIRED': '无需验证',
  'DOMAIN.NAME.CONFIG.NO.VERIFY.SUBMITTED': '域名验证申请已提交',
  'DOMAIN.NAME.CONFIG.NO.VERIFY.SUBMITTED.DESC':
    '发信域名 <b>{address}</b> 验证申请已提交',
  'DOMAIN.NAME.CONFIG.DEL.TITLE': '确认删除域名 "{address}"？',
  'DOMAIN.NAME.CONFIG.DEL.DESC':
    '删除会导致该域名不可再发送邮件，且操作不可撤回，请谨慎操作。',
  'DOMAIN.NAME.CONFIG.NOTE': '注意事项',
  'DOMAIN.NAME.CONFIG.NOTE0': '您需要具备发信域名的管理权限。',
  'DOMAIN.NAME.CONFIG.NOTE1':
    '域名配置，如果您的域名托管在腾讯云，请前往https://console.cloud.tencent.com/cns 进行配置。如果您的域名托管在其他域名服务商，请根据提供的清单自行进行配置。',
  'DOMAIN.NAME.CONFIG.NOTE2':
    '完成域名配置后，可能需要5分钟到2小时的时间进行同步。如果无法立即通过验证，请耐心等待。',
  'DOMAIN.NAME.CONFIG.NOTE3':
    '在域名验证完成后，请勿删除或修改已配置的 SPF 和 MX 记录，否则可能导致邮件发送异常。',
  'DOMAIN.NAME.CONFIG.NOTE4':
    '请勿使用企业邮箱域名，以免与 SPF 和 MX 记录产生冲突。',
  'DOMAIN.NAME.CONFIG.SEND.DOMAIN.NAME.CONFIG': '发送域名配置',
  'DOMAIN.NAME.CONFIG.TYPE': '类型',
  'DOMAIN.NAME.CONFIG.DOMAIN.NAME': '域名',
  'DOMAIN.NAME.CONFIG.RECORD.VALUE': '记录值',

  // 域名管理
  'SETTING.MANAGE.DOMAIN.AUTH': '域名认证',
  'SETTING.MANAGE.DOMAIN.AUTH_NEW_TITLE': '域名认证检查状态',
  'SETTING.MANAGE.DOMAIN.AUTH.DESC': '验证域名并根据需要新增发件人地址',
  'SETTING.MANAGE.DOMAIN.AUTH.DESC1':
    '验证你的发信域名，验证后此域名可应用在多个发件人地址中。',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD': '新增域名',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.DOMAIN': '域名',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.SPF.STATUS': 'SPF验证状态',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.DKM.STATUS': 'DKIM验证状态',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.CHECK.STATUS': '状态',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.VERIFY': '已验证',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.NOT.VERIFY': '未验证',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.GO.VERIFY': '验证',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.EXPORT': '导出配置信息',
  'SETTING.MANAGE.DOMAIN.AUTH.LIST.OPERATE.EXPORT.DISABLED.TIP':
    '配置信息更新中，请稍后再试',
  'SETTING.MANAGE.DOMAIN.AUTH.DELETE.TITLE': '确认删除此域名？',
  'SETTING.MANAGE.DOMAIN.AUTH.DELETE.MSG': '域名删除后，将无法使用此域名发件。',

  // 域名管理 - 新增
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.TITLE': '输入域名',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DESC':
    '请确保您对发信域名拥有管理权限',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.LABEL': '输入域名',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.HOLDER': 'example.com',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.PLACEHOLDER': '请输入要验证的域名',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.REST': 'sample.com',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.SUB.OVER': '已提交',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.INFO.TITLE': '配置域名验证的DNS记录',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.INFO.DESC':
    '您的域名管理员需要按照以下配置清单到域名服务商完成配置。一般在完成配置后的72小时内，域名的认证状态将变为“已认证”。',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.INFO.DKIM.LABEL': 'DKIM验证状态',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DKIM.MSG':
    'DKIM是一种基于DNS的邮件认证机制，旨在帮助SmartLink更有效地发送邮件，并获得收件服务商的信任。',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.INFO.SPF.LABEL': 'SPF验证状态',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.INFO.MORE.GUID':
    '更多指引请参考<a href="{ url }" target="_blank">如何验证发件域名</a>',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.CHECK.TITLE': '域名移除沙箱',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.CHECK.DESC':
    '在您的域名验证成功后，SmartLink将自动将您的域名从沙箱环境中移除，并为您初始化每日发送300万封电子邮件的配额。该过程通常需要1个工作日，请您耐心等待。如果您需要提升配额或有其他疑问，请通过电子邮件与SmartLink服务团队联系。',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.CHECK.LABEL': '{domain}',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.FORMAT': '请输入正确的域名格式',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.REPEAT': '此域名已被占用',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.SPF.MSG':
    'SPF是另一个基于DNS的邮件认证机制。',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.SPF.MSG.1':
    '如果您的域名没有现有的SPF记录，请使用以下值发布TXT记录。记录的名称可以为空或使用"@"，具体取决于您的DNS服务提供商。',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.SPF.MSG.2':
    'v=spf1 include:amazonses.com ~all',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.SPF.MSG.3':
    'SPF记录可以包含多个include语句。如果您的域已有SPF记录，您可以使用以下格式添加include语句:',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.SPF.MSG.4':
    'v=spf1 include:example.com include:amazonses.com ~all',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DMARC.TITLE': 'DMARC验证状态',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DMARC.DESC':
    '防范仿冒和钓鱼邮件，帮助避免邮件被标记为垃圾邮件。',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DMARC.NOTE':
    '提示:在配置DMARC之前，请先配置域名密识别邮件(DKIM)和发件人政策架(SPF)。启用DMARC前，DKIM和SPF应提前至少48小时完成邮件的身份验证。',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DMARC.CONFIG.DEMO': '首次配置示例:',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.DOMAIN.DMARC.CONFIG.SET':
    '后续配置修改，请参考: <a href="{ url }" target="_blank">设置说明</a>',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.INFO.GMAIL.LABEL': 'Gmail域名检测配置状态	',
  'SETTING.MANAGE.DOMAIN.AUTH.ADD.INFO.GMAIL.MSG':
    '配置完成后，Smartlink将监测您域名的 Gmail发送信誉。一旦检测到异常情况，系统会自动调整投递策略，以确保邮件能够成功送达。配置结果24小时内返回。',
  // 域名管理 - 详情页
  'SETTING.MANAGE.DOMAIN.DETAIL.LIST.TYPE': '类型',
  'SETTING.MANAGE.DOMAIN.DETAIL.LIST.DOMAIN.NAME': '主机记录名称',
  'SETTING.MANAGE.DOMAIN.DETAIL.LIST.VALUE': '值',
  'SETTING.MANAGE.DOMAIN.DETAIL.LIST.STATUS': '状态',

  // 发件地址管理
  'SETTING.MANAGE.SEND.ADDRESS': '发件地址',
  'SETTING.MANAGE.SEND.ADDRESS.DESC':
    '设置发件人地址后，可以立即在活动中使用它',
  'SETTING.MANAGE.SEND.ADDRESS.NO.DATA.TIPS1': '没有地址，',
  'SETTING.MANAGE.SEND.ADDRESS.NO.DATA.TIPS2': '你可以创建一个新地址',
  'SETTING.MANAGE.ADD.SEND.ADDRESS': '新增发件地址',
  'SETTING.MANAGE.EDIT.SEND.ADDRESS': '修改发件地址',
  'SETTING.MANAGE.EMAIL.ADDRESS': '邮箱地址',
  'SETTING.MANAGE.PLEASE.ENTER.EMAIL.ADDRESS': '请输入邮箱地址',
  'SETTING.MANAGE.PLEASE.ENTER.EMAIL.ADDRESS.BEFORE':
    '只能输入 数字、字母、下划线、短横线',
  'SETTING.MANAGE.SEND.ADDRESS.DESC1': '创建你认为可以作为发送域下的发件地址。',
  'SETTING.MANAGE.SEND.ADDRESS.DESC2':
    '一旦设置了通用的发件地址，您可以直接在设置活动时引用该地址。',
  'SETTING.MANAGE.SEND.ADDRESS.DESC3':
    '在发送之前完成设置将加快您创建活动的速度。',
  'SETTING.MANAGE.SEND.ADDRESS.DEL.TITLE': '确认删除此发件地址前缀？',
  'SETTING.MANAGE.SEND.ADDRESS.DEL.TIPS':
    '发件地址前缀删除后，将无法在创建活动中直接使用。',

  // 发件人管理
  'SETTING.MANAGE.FROM.NAME': '发件人名称',
  'SETTING.MANAGE.FROM.NAME.DESC': '请在发送活动件设置好发件人名称',
  'SETTING.MANAGE.ADD.FROM.NAME': '新增发件人名称',
  'SETTING.MANAGE.EDIT.FROM.NAME': '编辑发件人名称',
  'SETTING.MANAGE.FROM.NAME.DESC1':
    '根据您的需要，创建发送者。在发送前完成设置将有助于活动创建，未完成设置，活动创建将会被中断。',
  'SETTING.MANAGE.PLEASE.ENTER.FROM.NAME': '请输入发件人名称',
  'SETTING.MANAGE.FROM.NAME.DEL.TITLE': '确认删除此发件人名称？',
  'SETTING.MANAGE.FROM.NAME.DEL.TIPS':
    '发件人名称删除后，将无法在创建活动中直接使用。',

  // 测试邮箱管理
  'SETTING.MANAGE.TEST.LIST': '测试人名单',
  'SETTING.MANAGE.TEST.LIST.ADD': '新增测试人',
  'SETTING.MANAGE.TEST.LIST.DESC':
    '在您的活动发送给全部联系人名单之前，建议设置一个测试联系人名单，以便接收活动的测试版本。',
  'SETTING.MANAGE.TEST.ADD.TITLE': '新增',
  'SETTING.MANAGE.TEST.EDIT.TITLE': '编辑',
  'SETTING.MANAGE.SELECT.LANGUAGE': '请选择语言',
  'SETTING.MANAGE.PLEASE.ENTER.ADDRESS': '请输入正确的测试邮箱地址',
  'SETTING.MANAGE.PLEASE.ENTER.TEST.EMAIL.ADDRESS': '请输入测试邮箱地址',
  'SETTING.MANAGE.TEST.DEL.TITLE': '确认删除此测试人名单？',

  // API key - 列表
  'SETTING.MANAGE.API.KEY': 'API密钥',
  'SETTING.MANAGE.API.KEY.DESC': 'SmartLink的API使开发人员能够轻松集成',
  'SETTING.MANAGE.API.KEY.DESC1':
    "SmartLink的API使开发人员能够轻松集成 <a href={url} target='_blank'>了解更多</a>",

  'SETTING.MANAGE.API.KEY.CREATE': '创建密钥',
  'SETTING.MANAGE.API.KEY.ADD': '创建API密钥',
  'SETTING.MANAGE.API.KEY.EDIT': '编辑API密钥',
  'SETTING.MANAGE.API.KEY.REVOKE': '撤销 API 密钥',
  'SETTING.MANAGE.API.KEY.SAVE.AND.CONFIG': '保存并设置',
  'SETTING.MANAGE.API.KEY.CREATED.TIME': '创建时间',
  'SETTING.MANAGE.API.KEY.CREATED.BY': '创建人',
  'SETTING.MANAGE.API.KEY.REVOKE.ON.DATE': '撤销时间 {date}',
  'SETTING.MANAGE.API.KEY.HISTORY.TIPS': '历史数据，暂不支持设置和撤销',
  'SETTING.MANAGE.API.KEY.VALUE': 'API密钥',
  'SETTING.MANAGE.API.KEY.CREATE.TIPS.TITLE': '在开始之前，请记住：',
  'SETTING.MANAGE.API.KEY.CREATE.TIPS.1':
    '此弹窗内，您才能立即看到完整的密钥。密钥保存后，您将看不到实际的密钥，只能看到您为其指定的名称。',
  'SETTING.MANAGE.API.KEY.CREATE.TIPS.2':
    '为了您的安全，切勿与第三方共享您的 API 密钥。',
  'SETTING.MANAGE.API.KEY.NEW.VALUE': '新API密钥',
  'SETTING.MANAGE.API.KEY.NAME': '名称',
  'SETTING.MANAGE.API.KEY.NAME.PLACEHOLDER': '请输入API名称',
  'SETTING.MANAGE.API.KEY.NAME.NOT.EMPTY': '名称不可为空',
  'SETTING.MANAGE.API.KEY.REMARKS.PLACEHOLDER': '请输入',
  'SETTING.MANAGE.API.KEY.REMARKS.TIPS':
    '请输入描述性注释，以便您了解此 API 密钥的用途。',
  'SETTING.MANAGE.API.KEY.REVOKE.DESC.TITLE': '您确定要撤销这个密钥吗？',
  'SETTING.MANAGE.API.KEY.REVOKE.DESC.TIPS1':
    '密钥被撤销后，使用此密钥的API将无法更新数据到smartlink系统；',
  'SETTING.MANAGE.API.KEY.REVOKE.DESC.TIPS2':
    '请确认密钥撤销后，您的程序不会收到额外的影响。',
  'SETTING.MANAGE.API.KEY.REVOKE.CONFIRM.LABEL': '输入<b>【撤销】</b>进行确认',

  // API key - 详情
  'SETTING.MANAGE.API.KEY.DETAILS': 'API 密钥详细信息',
  'SETTING.MANAGE.API.KEY.DETAILS.BASIC.INFO': '基本信息',
  'SETTING.MANAGE.API.KEY.DETAILS.TIPS1':
    '为了您的安全，API密钥在创建后将不再可访问。',
  'SETTING.MANAGE.API.KEY.DETAILS.TIPS2':
    '如果丢失了密钥，则需要生成一个新密钥并更新使用它的集成。',
  'SETTING.MANAGE.API.KEY.DETAILS.TIPS3':
    '参考 <a href={url} target="_blank">Smartlink</a> 了解更多信息。',
  'SETTING.MANAGE.API.KEY.DETAILS.API.SETTINGS': 'API设置',
  'SETTING.MANAGE.API.KEY.DETAILS.API.SETTINGS.DESC':
    '若未设置，联系人通过API会直接加入联系人列表。<br/>您可以为API设置用户旅程 ',
  'SETTING.MANAGE.API.KEY.DETAILS.AUTOMATE.1':
    '用户旅程可为通过API进入的玩家发送二次确认邮件，确认后联系人才加入您的联系人列表:',
  'SETTING.MANAGE.API.KEY.DETAILS.AUTOMATE.2':
    '用户旅程可为新加入的联系人发送欢迎邮件:',

  // 拒绝列表
  'SETTING.MANAGE.REJECT.LIST': '拒绝列表',
  'SETTING.MANAGE.REJECT.LIST.DESC':
    '当您的电子邮件被退回或收件人将您的电子邮件标记为垃圾邮件时，SmartLink将在一段时间内停止向该地址发送更多电子邮件',
  'SETTING.MANAGE.REJECT.LIST.DESC.1':
    '当收件人退信或将您的邮件标记为垃圾邮件时，SmartLink会根据收件人的退信或投诉次数以及问题的严重程度，在一定时间内不再向该收件人发送更多的邮件。',
  'SETTING.MANAGE.REJECT.LIST.DESC.2':
    'SmartLink还将维护一个全局退信名单，在发送邮件之前自动进行过滤，并将退信邮箱与此名单同步。',
  'SETTING.MANAGE.REJECT.LIST.DESC.3':
    '您可以从拒绝列表中移除联系人邮箱，但请谨慎操作。如果您频繁从拒绝列表中移除联系人邮箱，可能会导致您的域名信誉度下降。',
  'SETTING.MANAGE.REJECT.LIST.ADD': '添加到拒绝列表',
  'SETTING.MANAGE.REJECT.LIST.SEARCH.PLACEHOLDER': '搜索拒绝列表',
  'SETTING.MANAGE.REJECT.LIST.EMAIL.ADDRESS': '邮箱地址',
  'SETTING.MANAGE.REJECT.LIST.REASON': '原因',
  'SETTING.MANAGE.REJECT.LIST.CUSTOM': '自定义',
  'SETTING.MANAGE.REJECT.LIST.INVALID.EMAIL': '无效地址',
  'SETTING.MANAGE.REJECT.LIST.INVALID.EMAIL.TIPS': '邮箱检查工具检测（{time}）',
  'SETTING.MANAGE.REJECT.LIST.HARD.BOUNCE': '硬反弹',
  'SETTING.MANAGE.REJECT.LIST.SPAM': '垃圾邮件',
  'SETTING.MANAGE.REJECT.LIST.LAST.JOIN.DATE': '最后添加日期',
  'SETTING.MANAGE.REJECT.LIST.LAST.ADDED.BY': '添加人',
  'SETTING.MANAGE.REJECT.LIST.EXPIRATION.DATE': '失效日期',
  'SETTING.MANAGE.REJECT.LIST.NEVER': '从不',
  'SETTING.MANAGE.REJECT.LIST.DOWNLOAD.SAMPLE.NAME': '下载CSV模板',
  'SETTING.MANAGE.REJECT.LIST.IMPORT.CSV.DROP.FILES.LIMIT':
    '仅支持csv格式，文件大小限制在20MB以内',
  'SETTING.MANAGE.REJECT.LIST.CANCEL.IMPORT.SUCCESS.TOTAL':
    "系统自动去除重复和格式错误的邮箱地址，本次可导入<span class='primary-weight-text'>{num}</span>联系人，点击确认后完成导入",
  'SETTING.MANAGE.REJECT.LIST.IMPORT.CSV.ERR.TYPE':
    '请将文档转换为CSV格式后再导入',
  'SETTING.MANAGE.REJECT.LIST.IMPORT.CSV.ERR.SIZE': '文件过大，请拆分导入',
  'SETTING.MANAGE.REJECT.LIST.IMPORT.CSV.ERR.EMAIL.NONE':
    '未识别到文件中包含有效的邮箱信息',

  // 拒绝列表 - 新增
  'SETTING.MANAGE.REJECT.ADD.DESC':
    '输入邮件地址并添加到您的拒绝列表，您手动添加的电子邮箱将长期有效',
  'SETTING.MANAGE.REJECT.ADD.EMAIL': '手动添加邮件地址',
  'SETTING.MANAGE.REJECT.ADD.EMAIL.PLACEHOLDER': '每行输入一个邮箱地址',
  'SETTING.MANAGE.REJECT.ADD.PLEASE.ENTER.EMAIL': '请输入邮件地址',
  'SETTING.MANAGE.REJECT.ADD.MAX.EMAIL':
    '输入的邮件地址超过了 {maxNum}，请删除并重新提交。',
  'SETTING.MANAGE.REJECT.ADD.FORMAT.EMAIL':
    '在[{errorIndex}]处输入的邮件地址格式不正确',
  'SETTING.MANAGE.REJECT.ADD.REPETITION.EMAIL':
    '输入的邮箱列表中存在重复的邮件地址，请删除后重试。',
  'SETTING.MANAGE.REJECT.ADD.EMAIL.NUM': '新增{num}邮件地址',
  'SETTING.MANAGE.REJECT.ADD.REASON': '原因',
  'SETTING.MANAGE.REJECT.ADD.PLEASE.ENTER.REASON': '请输入原因',
  'SETTING.MANAGE.REJECT.DEL.TITLE': '确认删除此邮件地址吗？',
  'SETTING.MANAGE.REJECT.DEL.DESC':
    '删除后，SmartLink 将会正常向此邮件地址发送邮件，但如果您遇到退信或用户投诉，将会损害您的域名信誉度。',
  'SETTING.MANAGE.REJECT.DEL.TOOLTIP.1':
    '自动加入列表的地址，暂不支持手动删除，<br/>如需删除请联系{customerServiceEmail}',
  'SETTING.MANAGE.REJECT.DEL.SUCCESS': '{email}已成功从拒绝列表中删除',
  'SETTING.MANAGE.REJECT.ADD.SUCCEEDED': '{num}个地址已被添加到您的拒绝列表中',
  'SETTING.MANAGE.REJECT.ADD.TAB.1': '手动上传',
  'SETTING.MANAGE.REJECT.ADD.TAB.2': '导入CSV',
  'SETTING.MANAGE.REJECT.ADD.DROP.FILES': '选择或拖拽文件到此处',

  // 发送频率控制
  'SENDING.FREQUENCY.CONTROL.EFFECTIVE.DATE': '*生效日期：{time}',
  'SENDING.FREQUENCY.CONTROL.EMAIL.FREQUENCE.TITLE': '邮件发送数量限制',
  'SENDING.FREQUENCY.CONTROL.EMAIL.FREQUENCE.DESC':
    '玩家在规定天数内，最多收到的电子邮件数量',
  'SENDING.FREQUENCY.CONTROL.ON.STATE.1':
    '<span class="color-primary font-weight-700">生效中</span>',
  'SENDING.FREQUENCY.CONTROL.ON.STATE.0':
    '<span class="color-999 font-weight-700">未开启</span>',
  'SENDING.FREQUENCY.CONTROL.RESTRICTION.EMAIL': '封邮件',
  'SENDING.FREQUENCY.CONTROL.HOUR': '小时',
  'SENDING.FREQUENCY.CONTROL.DAY': '天',
  'SENDING.FREQUENCY.CONTROL.WEEK': '周',
  'SENDING.FREQUENCY.CONTROL.MONTH': '月',
  'SENDING.FREQUENCY.CONTROL.TITLE': '防打扰策略',
  'SENDING.FREQUENCY.CONTROL.DESC': '避免在短时间内向一个人发送过多的营销邮件',
  'SENDING.FREQUENCY.CONTROL.SUB.DESC':
    '激活防打扰策略，帮助您在固定时间内，控制对单个玩家的发件数量',
  'SENDING.FREQUENCY.CONTROL.DESC.TIPS':
    '在活动模块创建的普通活动计入策略内，限制时间内:收件数量达到限制的玩家，不再投递。<br/>事务型邮件、欢迎邮件、二次确认邮件不计入策略内，可正常发送。<br/>普通活动想要跳过防打扰策略，可在发布时选择是否要跳过防打扰策略。',
  'SENDING.FREQUENCY.CONTROL.AUTH.TIPS': '请联系项目内管理类角色设置此策略',
  'SENDING.FREQUENCY.CONTROL.STATUS.1': '已激活',
  'SENDING.FREQUENCY.CONTROL.STATUS.0': '未激活',
  'SENDING.FREQUENCY.CONTROL.STATUS.DESC.1': '策略已激活，生效中',
  'SENDING.FREQUENCY.CONTROL.STATUS.DESC.0':
    '激活后，防打扰策略会对后来发布的活动生效',
  'SENDING.FREQUENCY.CONTROL.RESTRICTION.SET.TITLE': '策略设置',
  'SENDING.FREQUENCY.CONTROL.RESTRICTION.SET.DESC':
    '玩家在规定天数内，最多收到的电子邮件数量',
  'SENDING.FREQUENCY.CONTROL.STATUS.CHANGE.TITLE.0': '确认激活策略？',
  'SENDING.FREQUENCY.CONTROL.STATUS.CHANGE.DESC.0': '请确认策略信息',
  'SENDING.FREQUENCY.CONTROL.STATUS.CHANGE.TITLE.1': '确认取消激活？',
  'SENDING.FREQUENCY.CONTROL.STATUS.CHANGE.DESC.1':
    '取消激活后，策略不再生效。',
  'SENDING.FREQUENCY.CONTROL.STATUS.CHANGE.TO.1': '激活成功',
  'SENDING.FREQUENCY.CONTROL.STATUS.CHANGE.TO.0': '取消激活成功',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.TITLE': '策略变更确认',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.DESC':
    '‌<span class="color-666">您正在修改生效中的防打扰策略：</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.EFFECT':
    '确认后，系统将从今日起重新计算周期‌内的邮件发送数量。',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.SEND.OLD.1':
    '‌<span class="color-666">• 原策略：每 ‌[{days}]天‌ 允许发送 ‌[{num}]封邮件‌</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.SEND.OLD.2':
    '‌<span class="color-666">• 原策略：每 ‌[{days}]周 允许发送 ‌[{num}]封邮件‌</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.SEND.OLD.3':
    '‌<span class="color-666">• 原策略：每 ‌[{days}]月 允许发送 ‌[{num}]封邮件‌</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.SEND.NEW.1':
    '<b class="color-333">• 新策略：每 ‌[{days}]天‌ 允许发送 ‌[{num}]封邮件‌</b>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.SEND.NEW.2':
    '<b class="color-333">• 新策略：每 ‌[{days}]周‌ 允许发送 ‌[{num}]封邮件‌</b>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.SEND.NEW.3':
    '<b class="color-333">• 新策略：每 ‌[{days}]月‌ 允许发送 ‌[{num}]封邮件‌</b>',
  // 邮件发送冷却时间
  'SENDING.FREQUENCY.CONTROL.COOLING.TITLE': '邮件发送冷却时间',
  'SENDING.FREQUENCY.CONTROL.COOLING.DESC':
    '若发现距离上次发件时间小于冷却时间将自动过滤对应的收件人',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.COOLING.DESC':
    '‌<span class="color-666">您正在修改生效中的的防打扰策略：</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.COOLING.OLD.1':
    '‌<span class="color-666">• 原策略：邮件发送冷却时间为{num}小时</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.COOLING.OLD.2':
    '‌<span class="color-666">• 原策略：邮件发送冷却时间为{num}天</span>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.COOLING.NEW.1':
    '<b class="color-333">• 新策略：邮件发送冷却时间为{num}小时</b>',
  'SENDING.FREQUENCY.CONTROL.UPDATE.TACTICS.COOLING.NEW.2':
    '<b class="color-333">• 新策略：邮件发送冷却时间为{num}天</b>',

  // 回调
  'SETTING.MANAGE.WEB.HOOKS.TITLE': '回调',
  'SETTING.MANAGE.WEB.HOOKS.DESC': '创建回调以将事件实时同步至您的目标地址',
  'SETTING.MANAGE.WEB.HOOKS.ADD.YOUR.FIRST.WEBHOOK': '创建你的第一个回调',
  'SETTING.MANAGE.WEB.HOOKS.ADD.NEW.WEBHOOK': '新建一个新的回调',
  'SETTING.MANAGE.WEB.HOOKS.CREATE.NEW.WEBHOOK': '创建回调',
  'SETTING.MANAGE.WEB.HOOKS.ADD.WEBHOOK.MAX.TIPS': '达到最大触发值',
  'SETTING.MANAGE.WEB.HOOKS.URL': '跳转链接',
  'SETTING.MANAGE.WEB.HOOKS.TRIGGERED.BY': '触发事件',
  'SETTING.MANAGE.WEB.HOOKS.EVENTS': '事件次数',
  'SETTING.MANAGE.WEB.HOOKS.LAST.SUCCESSFUL.AT': '上次成功回调时间',
  'SETTING.MANAGE.WEB.HOOKS.KEY': '秘钥',
  'SETTING.MANAGE.WEB.HOOKS.LAST.EDIT.BY': '上次编辑人',
  'SETTING.MANAGE.WEB.HOOKS.KEY.DESC.TITLE': '秘钥说明',
  'SETTING.MANAGE.WEB.HOOKS.KEY.DESC.CONTENT':
    'SmartLink将对回调请求签名，以便您对请求认证。此步骤非必须但建议执行。',
  'SETTING.MANAGE.WEB.HOOKS.KEY.DESC.MORE.DETAILS': '更多详情',
  'SETTING.MANAGE.WEB.HOOKS.SEND.TEST': '发送测试',
  'SETTING.MANAGE.WEB.HOOKS.SEND.TEST.SUCCEEDED': '测试事件回调成功',
  'SETTING.MANAGE.WEB.HOOKS.DEL.HEADER': '确认删除',
  'SETTING.MANAGE.WEB.HOOKS.DEL.TIPS': '删除回调不可恢复，你确认继续此操作？',
  'SETTING.MANAGE.WEB.HOOKS.RESET.KEY': '重置秘钥',
  'SETTING.MANAGE.WEB.HOOKS.RESET.KEY.SUCCEEDED': '重置成功',
  'SETTING.MANAGE.WEB.HOOKS.RESET.KEY.HEADER': '重置秘钥?',
  'SETTING.MANAGE.WEB.HOOKS.RESET.KEY.TIPS1':
    '重置回调秘钥将会产生一个新的随机秘钥，并立即生效',
  'SETTING.MANAGE.WEB.HOOKS.ADD': '创建回调',
  'SETTING.MANAGE.WEB.HOOKS.EDIT': '编辑回调',
  'SETTING.MANAGE.WEB.HOOKS.URL.TO.POST.TO': 'Post请求URL地址',
  'SETTING.MANAGE.WEB.HOOKS.URL.TO.POST.TO.PLACEHOLDER':
    " 以'https://' or 'http://' 开始",
  'SETTING.MANAGE.WEB.HOOKS.WHEN.CONTACT.CHANGES.TO': '当联系人变更为',
  'SETTING.MANAGE.WEB.HOOKS.DESCRIPTION': '描述',

  // 收件人信息
  'SETTING.MANAGE.RECIPIENT.INFO': '收件人信息',
  'SETTING.MANAGE.AREA.MANAGE': '区域管理',
  'SETTING.MANAGE.AREA.MANAGE.DESC':
    '自定义联系人大区，支持按大区查看活动报表及筛选用户。',

  // 指引弹窗
  'SETTING.MANAGE.AREA.DIALOG.DESC':
    '区域管理帮助您整合多个区域到一个大区内，保存后支持按大区查看活动报表及筛选用户。',
  'SETTING.MANAGE.AREA.DIALOG.TIP1': '1、请先创建大区，选择区域归属',
  'SETTING.MANAGE.AREA.DIALOG.TIP2':
    '2、联系人报表，支持查看大区内区域的联系人数量汇总。',
  'SETTING.MANAGE.AREA.DIALOG.TIP3':
    '3、分层规则页面支持通过选择大区选中当前大区内的区域。',

  // 添加修改弹窗
  'SETTING.MANAGE.AREA.ADD.TITLE': '新增大区',
  'SETTING.MANAGE.AREA.ADD.NEW.CREATE': '新建大区',
  'SETTING.MANAGE.AREA.EDIT.TITLE': '编辑大区',
  'SETTING.MANAGE.AREA.ADD.PLACEHOLDER': '请输入大区名称',
  'SETTING.MANAGE.AREA.ADD.SELECTED': '选择区域',
  'SETTING.MANAGE.AREA.ADD.SELECT': '选择区域',
  'SETTING.MANAGE.AREA.ADD.SELECT.PLACEHOLDER': '请选择区域',
  'SETTING.MANAGE.AREA.SEARCH': '搜索区域',
  'SETTING.MANAGE.AREA.SEARCH.AREA': '搜索大区',
  'SETTING.MANAGE.AREA.ADD.CONFIRM': '确认',
  'SETTING.MANAGE.AREA.ADD.CANCEL': '取消',
  'SETTING.MANAGE.AREA.ADD.SUCCEEDED': '创建成功',
  'SETTING.MANAGE.AREA.EDIT.SUCCEEDED': '编辑成功',
  'SETTING.MANAGE.AREA.CREATE.ZONE.LABEL': '大区名称',
  'SETTING.MANAGE.AREA.NOT.EMPTY': '暂无大区可被选择，请新建',
  'SETTING.MANAGE.AREA.NAME.REQUIRED': '大区名称必填',
  'SETTING.MANAGE.AREA.NAME.UNABLE.EMPTY': '大区名称不能为空',
  'SETTING.MANAGE.AREA.NAME.EXIST': '大区名称已存在',
  'SETTING.MANAGE.AREA.ZONE.NAME': '大区名称',

  // 删除
  'SETTING.MANAGE.AREA.DEL.TITLE': '确认删除大区？',
  'SETTING.MANAGE.AREA.DEL.TIPS':
    '请确认是否删"<b class="color-333">{name}</b>"，删除后，大区不可见。大区中的区域会回到<b class="color-333">\'其他\'</b>中。',
  'SETTING.MANAGE.AREA.DEL.SUCCEEDED': '删除成功',

  // 移动区域
  'SETTING.MANAGE.AREA.MOVE': '移动区域',
  'SETTING.MANAGE.AREA.MOVE.CURRENT': '当前大区',
  'SETTING.MANAGE.AREA.MOVE.PLACEHOLDER': '选择要移动的区域',
  'SETTING.MANAGE.AREA.MOVE.TARGET': '目标大区',
  'SETTING.MANAGE.AREA.MOVE.SELECT': '选择大区',
  'SETTING.MANAGE.AREA.MOVE.SUCCEEDED': '移动成功',

  // 添加修改弹窗
  'SETTING.MANAGE.AREA.ADD.TITLE': '新增大区',
  'SETTING.MANAGE.AREA.EDIT.TITLE': '编辑大区',
  'SETTING.MANAGE.AREA.ADD.PLACEHOLDER': '请输入大区名称',
  'SETTING.MANAGE.AREA.ADD.SELECTED': '选择区域',
  'SETTING.MANAGE.AREA.ADD.SELECT.PLACEHOLDER': '请选择区域',
  'SETTING.MANAGE.AREA.SEARCH': '搜索区域',
  'SETTING.MANAGE.AREA.ADD.CONFIRM': '确认',
  'SETTING.MANAGE.AREA.ADD.CANCEL': '取消',
  'SETTING.MANAGE.AREA.ADD.SUCCEEDED': '创建成功',
  'SETTING.MANAGE.AREA.EDIT.SUCCEEDED': '编辑成功',

  // 删除
  'SETTING.MANAGE.AREA.DEL.TITLE': '确认删除大区？',
  'SETTING.MANAGE.AREA.DEL.TIPS':
    '请确认是否删"<b class="color-333">{name}</b>"，删除后，大区不可见。大区中的区域会回到<b class="color-333">\'其他\'</b>中。',
  'SETTING.MANAGE.AREA.DEL.SUCCEEDED': '删除成功',

  // 移动区域
  'SETTING.MANAGE.AREA.MOVE': '移动区域',
  'SETTING.MANAGE.AREA.MOVE.CURRENT': '当前大区',
  'SETTING.MANAGE.AREA.MOVE.PLACEHOLDER': '选择要移动的区域',
  'SETTING.MANAGE.AREA.MOVE.TARGET': '目标大区',
  'SETTING.MANAGE.AREA.MOVE.SELECT': '选择大区',
  'SETTING.MANAGE.AREA.MOVE.SUCCEEDED': '移动成功',

  // 区域管理
  'SETTING.MANAGE.AREA.DIVIDE': '区域划分',
  'SETTING.MANAGE.AREA.ZONE': '大区名称',
  'SETTING.MANAGE.AREA.REGION': '区域',
  'SETTING.MANAGE.AREA.ACTION': '操作',
  'SETTING.MANAGE.AREA.OTHER': '其他',
  'SETTING.MANAGE.AREA.EDIT': '编辑',
  'SETTING.MANAGE.AREA.DELETE': '删除',
  'SETTING.MANAGE.AREA.COLLAPSE': '收起',

  // 二次确认邮件配置
  'SETTING.MANAGE.OPT.IN.TITLE': '二次确认邮件',
  'SETTING.MANAGE.CREATE.MAIL.SUBJECT': '在这里输入主题',
  'SETTING.MANAGE.OPT.IN.DESC':
    '当通过 API 导入联系人或提交表单且订阅状态为“待确认”时，系统将自动发送此确认邮件。联系人需点击确认以完成订阅。',
  'SETTING.MANAGE.OPT.IN.DESC.2':
    '当通过 API（V4 或更高版本）以“待确认”状态导入联系人时，系统将自动发送此确认邮件。只有手动确认的联系人才会转为“已订阅”。',
  'SETTING.MANAGE.OPT.IN.ACTIVE': '已配置',
  'SETTING.MANAGE.OPT.IN.NOT.ACTIVE': '未配置',
  'SETTING.MANAGE.OPT.IN.EXPAND.DESC': '导入联系人设置',
  'SETTING.MANAGE.OPT.IN.COLLAPSE': '展开并配置',
  'SETTING.MANAGE.OPT.IN.DEFAULT.SETTING.TITLE': '二次确认邮件默认设置',
  'SETTING.MANAGE.OPT.IN.DEFAULT.SETTING.DESC':
    '此处配置的二次确认邮件发件人信息和发件内容，可在API和表单创建流程中直接应用。',
  'SETTING.MANAGE.OPT.IN.SETTING.TITLE': '二次确认邮件配置',
  'SETTING.MANAGE.OPT.IN.SETTING.SAVE.AND.BACK': '保存并返回',
  'SETTING.MANAGE.OPT.IN.IMPORT.CONTACT.CONFIG': '导入联系人配置',
  'SETTING.MANAGE.OPT.IN.IMPORT.CONTACT.CONFIG.TIPS1':
    '配置仅对V4及以上版本API生效',
  'SETTING.MANAGE.OPT.IN.IMPORT.CONTACT.CONFIG.TIPS2':
    '若要通过此API导入联系人，请确保完成这些配置。',
  'SETTING.MANAGE.OPT.IN.TO.CONFIG': '去配置',
  'SETTING.MANAGE.OPT.IN.DEFAULT.CONFIG': '默认配置',
  'SETTING.MANAGE.OPT.IN.DEFAULT.CONFIG.TIPS1': '默认配置尚未完成，请前往',
  'SETTING.MANAGE.OPT.IN.DEFAULT.CONFIG.TIPS2': '配置',
  'SETTING.MANAGE.OPT.IN.CUSTOM.CONFIG': '自定义配置',
  'SETTING.MANAGE.OPT.IN.CUSTOM.CONFIG.SETTINGS': '自定义配置设置',
  'SETTING.MANAGE.OPT.IN.SAVE.DESC':
    '配置保存后，所有应用此配置的API和表单的二次确认邮件的发件信息和发件内容会同步修改，请谨操作。',

  'SETTING.MANAGE.OPT.IN.METHOD.SINGLE.TITLE': '单次确认',
  'SETTING.MANAGE.OPT.IN.METHOD.SINGLE.DESC':
    '新联系人提交表单后将立即被添加至订阅列表。此方式能最大化地提升列表增长速度。',
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.PARTICULAR.TITLE':
    '智能二次确认订阅（推荐）',
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.PARTICULAR.TIPS':
    '{country}。在上述国家/地区，法律要求“双重选择加入”。',
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.PARTICULAR.DESC1':
    '新联系人需要通过确认邮件进行验证后，才会被正式订阅。在确认前，其订阅状态为“待确认 (Pending)”。此模式会为特定国家/地区的用户自动启用，以帮助您符合当地法律要求，同时简化其他地区用户的订阅流程。',
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.PARTICULAR.DESC2':
    '当前适用地区： <span class="color-333 font-weight-700">{country}</span>。',
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.ALL.TITLE': '对所有用户使用二次确认订阅',
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.ALL.DESC1':
    '无论来自任何地区，新联系人都需要通过确认邮件进行验证。在确认前，其订阅状态为“待确认 (Pending)”。此方式能确保最高质量的联系人列表，并明确地获得用户的订阅意愿。',
  'SETTING.MANAGE.OPT.IN.METHOD.DOUBLE.ALL.DESC2':
    '玩家点击邮件中的确认链接后，订阅状态才会更新为“已订阅”。',
  'SETTING.MANAGE.OPT.IN.METHOD.CUSTOMIZED.TEMPLATES': '自定义邮件模板 - ',
  'SETTING.MANAGE.OPT.IN.TEMPLATE.SELECT.LABEL': '模板类型',
  'SETTING.MANAGE.OPT.IN.SYNC.CONTACT.SUCCESS': '已同步',
  'SETTING.MANAGE.OPT.IN.TEMPLATE.SELECT.BUBBLE':
    '若选择系统内置模板，自动填充主题和模板内容，只需填写模板内的邮箱地址即可；<br/>选择营销邮件模板，需根据需要到各个语种下填写主题和模板内容；',
  'SETTING.MANAGE.OPT.IN.TEMPLATE.OPTIONS1': '系统内置模板',
  'SETTING.MANAGE.OPT.IN.TEMPLATE.OPTIONS2': '营销邮件模板',
  'SETTING.MANAGE.OPT.IN.SYNC.CONTACT': '同步到其他语言',
  'SETTING.MANAGE.OPT.IN.SELECT.TEMP.TIPS':
    ' 仅包含二次确认链接且不包含资源码的模板是可选的',
  'SETTING.MANAGE.OPT.IN.SELECT.TEMP.TIPS.2':
    '仅包含二次确认链接且不包含资源码和表单的模板',
  'SETTING.MANAGE.OPT.IN.BUILT.IN.TEMP.LABEL': '内置邮件模板',
  'SETTING.MANAGE.OPT.IN.BUILT.IN.TEMP.DEFAULT.TEMPLATE.LABEL':
    '默认二次确认邮件模板',
  'SETTING.MANAGE.OPT.IN.CONFIRM.HEADER': '确认是否保存修改内容',
  'SETTING.MANAGE.OPT.IN.CONFIRM.TIPS': '保存后，配置内容将立即生效',
  'SETTING.MANAGE.OPT.IN.CHECKBOX.SELECT': '将此二次确认邮件内容保存至默认配置',
  'SETTING.MANAGE.OPT.IN.SELECT.TIPS':
    '如果保存默认配置，该内容将自动应用到其他API或表单中',
  // 错误码提示
  'SETTING.SENDER.ADDRESS.10093': '请检查 二次确认邮件发件地址设置',
  'SETTING.SENDER.NAME.10094': '请检查 二次确认邮件发件人名称设置',
};
